import { render, staticRenderFns } from "./StoresReportView.vue?vue&type=template&id=32c7e998"
import script from "./StoresReportView.vue?vue&type=script&lang=js"
export * from "./StoresReportView.vue?vue&type=script&lang=js"
import style0 from "./StoresReportView.vue?vue&type=style&index=0&id=32c7e998&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports